export class Cylinder {

  cylinder_Id = 0;

  cyl_Size_Id = 0;
  cyl_Size = '';

  cyl_Material_Id = 0;
  cyl_Material = '';

}
